import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MainLayout = () => {
  useEffect(() => {
    const $ = window.jQuery;
    if (!$) return;

    // The template's own script.js does this same thing, but it runs on
    // document-ready — before React has rendered the header — so it always
    // no-ops in this SPA. Redo it here, after the real DOM exists.
    if ($(".mobile-menu").length) {
      const mobileMenuContent = $(".main-header .main-menu .navigation").html();
      $(".mobile-menu .navigation").html(mobileMenuContent);
      $(".sticky-header .navigation").html(mobileMenuContent);
    }

    $(".mobile-nav-toggler")
      .off("click.mainLayout")
      .on("click.mainLayout", function () {
        $("body").addClass("mobile-menu-visible");
      });

    $(".mobile-menu .menu-backdrop, .mobile-menu .close-btn")
      .off("click.mainLayout")
      .on("click.mainLayout", function () {
        $("body").removeClass("mobile-menu-visible");
      });
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <Header />
        <Outlet />
        <Footer />
      </div>
    </>
  );
};

export default MainLayout;
